import { mapChannelListToTable } from '@/utils/Campaigns';
import api from './api';

export function generateChannelColumns() {
  const sources = api.getAllSource();
  const channels = [
    {
      // title: 'Share of Voice (SOV)',
      dataIndex: 'type',
      key: 'type',
      fixed: 'left',
      // width: 250,
      slots: { title: 'customTypeTitle', customRender: 'type' },
    },
  ];
  const channelList = [
    {
      // title: 'Facebook'
      key: 'facebook',
      slots: { title: 'customFacebookTitle' },
    },
    {
      // title: 'Twitter',
      key: 'twitter',
      slots: { title: 'customTwitterTitle', customRender: 'twitter' },
    },
    {
      // title: 'Instagram',
      key: 'instagram',
      slots: { title: 'customInstagramTitle', customRender: 'instagram' },
    },
    {
      // title: 'Youtube',
      key: 'youtube',
      slots: { title: 'customYoutubeTitle', customRender: 'youtube' },
    },
    {
      // title: 'Pantip',
      key: 'pantip',
      slots: { title: 'customPantipTitle', customRender: 'pantip' },
    },
    {
      // title: 'Blockdit',
      key: 'blockdit',
      slots: { title: 'customBlockditTitle', customRender: 'blockdit' },
    },
    {
      // title: 'Tiktok',
      key: 'tiktok',
      slots: { title: 'customTiktokTitle', customRender: 'tiktok' },
    },
    {
      // title: 'Website',
      key: 'website',
      slots: { title: 'customWebsiteTitle', customRender: 'website' },
    },
  ];

  let channelsInfo = sources
    .map((source) => channelList.find((v) => v.key === source))
    .map(mapChannelListToTable);
  for (const c of channelsInfo) {
    channels.push(c);
  }
  return channels;
}
